<template>
  <div>

    <b-row>
      <b-col
          md="12"
          sm="12"
      >
        <b-tabs content-class="mt-2">
          <b-tab title="Reisetyp" :active="Step == 0" @click="SetStep(0)"></b-tab>
          <b-tab title="Reisetag" :active="Step == 1" @click="SetStep(1)"></b-tab>
          <b-tab title="Fahrgäste" :active="Step == 2" @click="SetStep(2)"></b-tab>
          <b-tab title="Weitere Fahrgäste und Infomationen" :active="Step == 3" @click="SetStep(3)"></b-tab>
          <b-tab title="Zielinfomation" :active="Step == 4" @click="SetStep(4)"></b-tab>
          <b-tab title="Zusammenfassung" :active="Step == 5" @click="SetStep(5)"></b-tab>
        </b-tabs>

        <b-card-code
            title="1. Reisetyp"
            v-show="(Step == 0)"
        >
          <span>Wählen sie ob es Sich um eine Einzelfahr oder eine Hin und Rückfahrt handelt.</span>
          <b-row
              class="mt-3"
          >
            <b-col
                md="6"
                sm="6"
            >
              <b-button
                  :variant="SelectedType == 1 ? 'success' : 'info'"
                  class="btn-block"
                  @click="SelectTravelType(1)"
              >
                Einzelfahrt
              </b-button>
            </b-col>
            <b-col
                md="6"
                sm="6"
            >
              <b-button
                  :variant="SelectedType == 2 ? 'success' : 'info'"
                  class="btn-block"
                  @click="SelectTravelType(2)"
              >
                Hin und Rückfahrt
              </b-button>
            </b-col>
          </b-row>
        </b-card-code>

        <b-card-code
            title="2. Reisetag/e"
            v-show="(Step == 1 && Step != 0)"
        >
          <span>Tagen sie bitte hier den Reisetag ein. Bei hin und rückfahrt. Links Hinfahrt und rechts rückfahrt.</span>
          <b-row
          >
            <b-col
                md="6"
                sm="6"
            >

              <b-input-group
                  class="input-group-merge"
                  :prepend="TravelData1.DayFieldName"
                  v-show="!TravelData1.DayFieldHidden"
              >

                <cleave
                    id="date"
                    v-model="vData.Trip.TravelDay"
                    class="form-control"
                    :raw="false"
                    :options="options.date"
                    placeholder="DD.MM.YYYY"
                    ref="TravelDay"
                    size="sm"
                />
                <b-input-group-append>
                  <b-form-datepicker
                      v-model="DatePicker.Trip.TravelDay"
                      show-decade-nav
                      button-only
                      right
                      locale="de-DE"
                      class="form-control"
                      start-weekday="1"
                      @context="onTripDatePickerContext"
                  />
                </b-input-group-append>

              </b-input-group>
            </b-col>
            <b-col
                md="6"
                sm="6"
            >
              <b-input-group
                  class="input-group-merge"
                  :prepend="TravelData2.DayFieldName"
                  v-show="!TravelData2.DayFieldHidden"
              >

                <cleave
                    id="date"
                    v-model="vData.ReturnTrip.TravelDay"
                    class="form-control"
                    :raw="false"
                    :options="options.date"
                    placeholder="DD.MM.YYYY"
                    ref="ReturnTravelDay"
                    size="sm"
                />
                <b-input-group-append>
                  <b-form-datepicker
                      v-model="DatePicker.ReturnTrip.TravelDay"
                      show-decade-nav
                      button-only
                      right
                      locale="de-DE"
                      class="form-control"
                      start-weekday="1"
                      @context="onReturnTripDatePickerContext"
                  />
                </b-input-group-append>

              </b-input-group>
            </b-col>
          </b-row>
          <b-button
              class="mt-2 float-left"
              variant="dark"
              size="sm"
              @click="Step = 0"
          >
            Zurück
          </b-button>
          <b-button
              class="mt-2 float-right"
              variant="dark"
              size="sm"
              @click="SetStep(2)"
          >
            Weiter
          </b-button>
        </b-card-code>

        <b-card-code
            title="3. Fahrgäste"
            v-show="(Step == 2 && Step != 0) || true"
        >


          <validation-observer ref="simpleRules">
            <span id>Tagen Sie hier bitte die Fahrgastinformationen ein. </span>
            <b-badge
                pill
                variant="primary"
                class="float-right"
            >
              Diese Adresse ist gleichzeitig die Abholadresse!
            </b-badge>
            <b-row
                class="mt-3"
            >
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Nachname des Fahrgastes"
                >
                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        id="Name"
                        placeholder=""
                        v-model="vData.Origin.Contact.Name"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Vorname des Fahrgastes"
                >

                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        id="Name"
                        placeholder=""
                        v-model="vData.Origin.Contact.Firstname"
                    />

                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
              </b-col>
              <b-col
                  md="12"
                  xl="12"
                  class="mb-1"
              >
                <b-form-group
                    label="Adresse"
                >

                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        v-model="vData.Origin.Address.Street"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Postleitzahl"
                >

                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <cleave
                        :options="options.number"
                        class="form-control"
                        :state="errors.length > 0 ? false:null"
                        id="ZipCode"
                        v-model="vData.Origin.Address.ZipCode"
                    />

                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Ort"
                >

                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        id="Location"
                        v-model="vData.Origin.Address.Location"
                    />

                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Ortsteil"
                >

                  <validation-provider
                      #default="{ errors }"
                      rules=""
                  >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        id="District"
                        v-model="vData.Origin.Address.District"
                    />

                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Telefon"
                >
                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <cleave
                        :options="options.number"
                        class="form-control"
                        id="Phone"
                        :state="errors.length > 0 ? false:null"
                        v-model="vData.Origin.Contact.Phone"
                    />
                  </validation-provider>

                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Handy"
                >
                  <validation-provider
                      #default="{ errors }"
                      rules=""
                  >
                    <cleave
                        :options="options.number"
                        class="form-control"
                        :state="errors.length > 0 ? false:null"
                        id="PassengerPhone2"
                        v-model="vData.Origin.Contact.Phone2"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="E-Mail"
                >

                  <validation-provider
                      #default="{ errors }"
                      rules="email"
                  >
                    <b-form-input
                        :state="errors.length > 0 ? false:null"
                        class="index_passengeremail"
                        id="PassengerEmail"
                        v-model="vData.Origin.Contact.Email"
                    />

                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <div v-for="(so, index) in vData.Stopovers">
              <hr>
              <h4>{{(index+2)}}. Adresse</h4>
              <b-row
                  class="mt-3"
              >
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Nachname des Fahrgastes"
                  >
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                      <b-form-input
                          :state="errors.length > 0 ? false:null"
                          id="Name"
                          placeholder=""
                          v-model="so.Contact.Name"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Vorname des Fahrgastes"
                  >

                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                      <b-form-input
                          :state="errors.length > 0 ? false:null"
                          id="Name"
                          placeholder=""
                          v-model="so.Contact.Firstname"
                      />

                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                </b-col>
                <b-col
                    md="12"
                    xl="12"
                    class="mb-1"
                >
                  <b-form-group
                      label="Adresse"
                  >

                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                      <b-form-input
                          :state="errors.length > 0 ? false:null"
                          v-model="so.Address.Street"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Postleitzahl"
                  >

                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                      <cleave
                          :options="options.number"
                          class="form-control"
                          :state="errors.length > 0 ? false:null"
                          id="ZipCode"
                          v-model="so.Address.ZipCode"
                      />

                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Ort"
                  >

                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                      <b-form-input
                          :state="errors.length > 0 ? false:null"
                          id="Location"
                          v-model="so.Address.Location"
                      />

                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Ortsteil"
                  >

                    <validation-provider
                        #default="{ errors }"
                        rules=""
                    >
                      <b-form-input
                          :state="errors.length > 0 ? false:null"
                          id="District"
                          v-model="so.Address.District"
                      />

                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Telefon"
                  >
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                      <cleave
                          :options="options.number"
                          class="form-control"
                          id="Phone"
                          :state="errors.length > 0 ? false:null"
                          v-model="so.Contact.Phone"
                      />
                    </validation-provider>

                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="Handy"
                  >
                    <validation-provider
                        #default="{ errors }"
                        rules=""
                    >
                      <cleave
                          :options="options.number"
                          class="form-control"
                          :state="errors.length > 0 ? false:null"
                          id="PassengerPhone2"
                          v-model="so.Contact.Phone2"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                    class="mb-1"
                >
                  <b-form-group
                      label="E-Mail"
                  >

                    <validation-provider
                        #default="{ errors }"
                        rules="email"
                    >
                      <b-form-input
                          :state="errors.length > 0 ? false:null"
                          class="index_passengeremail"
                          id="PassengerEmail"
                          v-model="so.Contact.Email"
                      />

                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <b-button
                class="mt-2 float-left"
                variant="dark"
                size="sm"
                @click="Step = 1"
            >
              Zurück
            </b-button>
            <b-button
                class="mt-2 float-right"
                variant="dark"
                size="sm"
                @click="SetStep(3)"
            >
              Weiter
            </b-button>
            <b-button
                class="mt-2 mr-1 float-right"
                variant="info"
                size="sm"
                @click="AddStopover()"
            >
              Weitere Addresse hinzufügen
            </b-button>
          </validation-observer>

        </b-card-code>


        <b-card-code
            title="4. Weitere Fahrgäste und Infomationen"
            v-show="(Step == 3 && Step != 0)"
        >
          <span>Hier können die anzahl der weiteren Mitreisenden und weitere Infomationen zur Buchung erfasst werden..</span>
          <b-col
              md="6"
              xl="6"
              class="mt-2"
          >
            <b-form-group
                label="Weitere Erwachsene (Fahrgäste ohne Hauptfahrgast)"
            >
              <b-form-select
                  v-model="vData.Passenger"
                  :options="PassengerOptions1"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="6"
              xl="6"
          >
            <b-form-group
                label="Weitere Kinder (Fahrgäste)"
            >
              <b-form-select
                  v-model="vData.PassengersChildren"
                  :options="PassengerOptions2"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="2"
              xl="2"
              v-show="vData.PassengersChildren > 0"
          >
            <b-form-group
                v-for="c in vData.PassengersChildren"
                :label="'Alter des Kindes ('+c+')'"
            >

              <cleave
                  id="date"
                  v-model="Passenger.ageOfTheChild[c]"
                  class="form-control"
                  :raw="false"
                  :options="options.number"
              />
            </b-form-group>
          </b-col>

          <b-col
              md="6"
              xl="6"
              class="mb-1"
          >
            <b-form-group
                label="Zusätzliche Optionen"
            >
              <b-form-select
                  v-model="vData.Equipment"
                  :options="EquipmentList"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="6"
              xl="6"
              class="mt-2"
          >
            <b-form-group
                label="Weitere Infomationen "
            >
              <span style="font-size: smaller">Tragen Sie Ihr weitere Wünsche oder Informationen ein.</span>
              <b-form-input
                  v-model="DescriptionPdf"
              />
            </b-form-group>
          </b-col>

          <b-button
              class="mt-2 float-left"
              variant="dark"
              size="sm"
              @click="Step = 2"
          >
            Zurück
          </b-button>
          <b-button
              class="mt-2 float-right"
              variant="dark"
              size="sm"
              @click="SetStep(4)"
          >
            Weiter
          </b-button>
        </b-card-code>

        <b-card-code
            title="5. Zielinfomation"
            v-show="(Step == 4 && Step != 0)"
        >
          <span>Tragen Sie hier die Zeilinfomationen.</span>
          <b-row
              class="mt-3"
          >

            <b-col
                md="6"
                sm="6"
            >
              <b-button
                  :variant="DescriptionType == 1 ? 'success' : 'info'"
                  class="btn-block"
                  @click="SelectDestinationType(1)"
              >
                Flughafen Leipzig (LEJ)
              </b-button>
            </b-col>
            <b-col
                md="6"
                sm="6"
            >
              <b-button
                  :variant="DescriptionType == 2 ? 'success' : 'info'"
                  class="btn-block"
                  @click="SelectDestinationType(2)"
              >
                Eine beliebige Adresse
              </b-button>
            </b-col>

            <b-col
                md="12"
                xl="12"
                class="mb-1 mt-3"
            >
              <b-badge
                  pill
                  variant="primary"
                  class="float-right"
              >
                Diese Abholadresse ist gleichzeitig die Zeiladresse bei der Rückfahrt!
              </b-badge>
            </b-col>
            <b-col
                md="2"
                xl="2"
                class="mb-1 mt-3"
                v-show="DescriptionType == 1"
            >
              <b-form-group
                  label="Flugnummer (Hinfahrt)"
              >
                <b-form-input
                    v-model="vData.Origin.Flight.Iata"
                    @blur="GetIata(1)"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
                class="mb-1 mt-3"
                v-show="DescriptionType == 1"
            >
              <b-form-group
                  label="Flugziel"
              >
                <b-form-input
                    v-model="vData.Origin.Flight.Departure"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
                class="mb-1 mt-3"
                v-show="DescriptionType > 0"
            >
              <b-form-group
                  label=""
                  :label="DescriptionType == 1 ? 'Abflugszeit' : 'Abholzeit (Hinfahrt)'"
              >
                <cleave
                    v-model="vData.ReturnTrip.Pickup"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                />

              </b-form-group>
            </b-col>

            <b-col
                md="2"
                xl="2"
                class="mb-1 mt-3"
                v-show="SelectedType == 2"
            >
              <b-form-group
                  label="Flugnummer (Rückfahrt)"
              >
                <b-form-input
                    v-model="vData.Destination.Flight.Iata"
                    @blur="GetIata(2)"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
                class="mb-1 mt-3"
                v-show="DescriptionType == 1 && SelectedType == 2"
            >
              <b-form-group
                  label="Abflugsort"
              >
                <b-form-input
                    v-model="vData.Origin.Flight.Departure"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
                class="mb-1 mt-3"
                v-show="SelectedType == 2 && DescriptionType > 0"
            >
              <b-form-group
                  :label="DescriptionType == 1 ? 'Ankuntszeit' : 'Anholzeit (Rückfahrt)'"
              >
                <cleave
                    v-model="vData.ReturnTrip.Pickup"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="12"
                xl="12"
                class="mb-1 mt-3"
                v-show="DescriptionType > 0"
            >
              <b-form-group
                  label="Adresse"
              >
                <b-form-input
                    v-model="vData.Destination.Address.Street"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
                class="mb-1"
                v-show="DescriptionType > 0"
            >
              <b-form-group
                  label="Postleitzahl"
              >
                <cleave
                    :options="options.number"
                    class="form-control"
                    #default="{ errors }"
                    rules="required"
                    v-model="vData.Destination.Address.ZipCode"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
                class="mb-1"
                v-show="DescriptionType > 0"
            >
              <b-form-group
                  label="Ort"
              >
                <b-form-input
                    id="Location"
                    v-model="vData.Destination.Address.Location"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
                class="mb-1"
                v-show="DescriptionType > 0"
            >
              <b-form-group
                  label="Ortsteil"
              >
                <b-form-input
                    id="District"
                    v-model="vData.Destination.Address.District"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-button
              class="mt-2 float-left"
              variant="dark"
              size="sm"
              @click="Step = 3"
          >
            Zurück
          </b-button>
          <b-button
              class="mt-2 float-right"
              variant="dark"
              size="sm"
              @click="SetStep(5)"
          >
            Weiter
          </b-button>
        </b-card-code>

        <b-card-code
            title="6. Zusammenfassung"
            v-show="(Step == 5)"
        >

          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <h4>Hinfahrt</h4>
            <li>Aholtag: {{ vData.Trip.TravelDay }}</li>
            <li>Aholzeit: {{ vData.Trip.Pickup }} Uhr</li>
            <li>Flug: {{ vData.Origin.Flight.Iata }} Abflug {{ vData.Origin.Flight.ScheduledTime }} Uhr</li>
            <li>{{ vData.Origin.Flight.Arrivals }} => {{ vData.Origin.Flight.Departure }}</li>

            <div v-show="SelectedType == 2">
              <h4 class="mt-3">Rückfahrt</h4>
              <li>Aholtag: {{ vData.ReturnTrip.TravelDay }}</li>
              <li>Aholzeit: {{ vData.ReturnTrip.Pickup }} Uhr</li>
              <li>Flug: {{ vData.Destination.Flight.Iata }} Ankunft {{ vData.Destination.Flight.ScheduledTime }} Uhr</li>
              <li>{{ vData.Destination.Flight.Arrivals }} => {{ vData.Destination.Flight.Departure }}</li>
            </div>

            <h4 class="mt-3">Fahrgäste</h4>
            <li>{{ vData.Origin.Contact.Name }}, {{ vData.Origin.Contact.Firstname }}</li>
            <li v-show="vData.Passenger > 1">+{{ (vData.Passenger - 1) }} weitere Fahrgäste</li>
            <li v-show="vData.PassengersChildren > 0">+{{ vData.PassengersChildren }} weitere Fahrgäste (Kinder)</li>
            <li>Zusätzliche Option: {{ vData.Equipment }}</li>
            <li>Weitere Infomationen:</li>

            <h4 class="mt-3">Abholadresse</h4>
            <li>{{ vData.Origin.Address.Street }}</li>
            <li>{{ vData.Origin.Address.ZipCode }} {{ vData.Origin.Address.Location }} {{ vData.Origin.Address.District }}</li>

            <h4 class="mt-3">Zeiladresse</h4>
            <li>{{ vData.Destination.Address.Street }}</li>
            <li>{{ vData.Destination.Address.ZipCode }} {{ vData.Destination.Address.Location }} {{ vData.Destination.Address.District }}</li>

            <h4 class="mt-3">Preis</h4>
            <b-badge
                pill
                variant="dark"
                class="float-right"
            >
              Bezahlung erfolgt bei der Hinfahrt in Bar oder EC beim Fahrer
            </b-badge>
            <div
                v-show="vData.Price == 0"
                class="spinner-border spinner-border-sm"
                role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>

            <div v-show="Loading.Price">
              <b-spinner
                  class="mr-1 mt-1"
                  variant="info"
              />
              <span class="font-medium-3">Preis wird berechnet.</span>
            </div>
            <div v-show="!Loading.Price">

              <li v-show="vData.Price != 0">Hinfahrt {{ vData.Trip.Price }}</li>
              <li v-show="SelectedType == 2 && vData.Price != 0">Rückfahrt {{ vData.ReturnTrip.Price }}</li>
              <li v-show="vData.Price != 0">Summe {{ vData.Price }}</li>
            </div>

          </b-col>

          <b-button
              variant="info"
              class="btn-block mt-2"
              @click="Finish"
          >
            Buchung abschließen
          </b-button>


          <b-button
              class="mt-2 float-left"
              variant="dark"
              size="sm"
              @click="SetStep(4)"
          >
            Zurück
          </b-button>
        </b-card-code>


      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BAvatar, BBadge, BButton, BCol, BDropdown, BDropdownItem, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupAppend, BPagination, BRow, BTable, BTabs, BTab, BFormDatepicker, BSpinner } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Cleave from 'vue-cleave-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import visualDefault from 'echarts/src/visual/visualDefault'

export default {
  name: 'Voucher',
  components: {
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
    Cleave,
    BSpinner
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      SelectedType: 0,
      Step: 0,
      Loading: {
        Price: true,
      },
      StopoverTemplate: {
        Address: {
          Street: 'Ringstr. 128',
          ZipCode: '04209',
          Location: 'Leipzig',
          District: '',
        },
        Contact: {
          Name: 'Cortellini',
          Firstname: 'Justin',
          Phone: '0157796666666',
          Phone2: '',
          Fax: '',
          Email: 'info2@scheffi.eu',
          Web: ''
        },
        PickupTime: '22:55',
        InfoText: ''
      },
      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numericOnly: true,
          blocks: [16],
          delimiters: [""]
        },

      },
      DatePicker: {
        Trip: {
          TravelDay: null,
          formatted: '',
          selected: '',
        },
        ReturnTrip: {
          TravelDay: null,
          formatted: '',
          selected: '',
        }
      },
      vData: {
        Trip: {
          TravelDay: '31.12.2022',
          Pickup: '9:00',
          Price: 0.00,
        },
        Stopovers: [],
        ReturnTrip: {
          TravelDay: '03.01.2023',
          Pickup: '22:55',
          Price: 0.00,
        },
        Passenger: 1,
        PassengersChildren: 0,
        Origin: {
          Flight: {
            Iata: 'LH164',
            Departure: 'FRA',
            Arrivals: 'LEJ',
            ScheduledTime: '11:30',
          },
          Address: {
            Street: 'Ringstr. 125',
            ZipCode: '04209',
            Location: 'Leipzig',
            District: '',
          },
          Contact: {
            Name: 'Cortellini',
            Firstname: 'Kevin',
            Phone: '015779325808',
            Phone2: '',
            Fax: '',
            Email: 'info@scheffi.eu',
            Web: ''
          },
        },
        Destination: {
          Flight: {
            Iata: 'LH165',
            Departure: 'LEJ',
            Arrivals: 'FRA',
            ScheduledTime: '22:55',
          },
          Address: {
            Street: 'Terminalring 11',
            ZipCode: '04435',
            Location: 'Schkeuditz',
            District: '',
          },
          Contact: {
            Name: '',
            Firstname: '',
            Phone: '',
            Phone2: '',
            Fax: '',
            Email: '',
            Web: ''
          },
        },
        Equipment: 0
      },
      TravelData1: {
        DayFieldName: 'Einzelfahrt',
        DayFieldHidden: false
      },
      TravelData2: {
        DayFieldName: 'Datum Rückfahrt',
        DayFieldHidden: true
      },
      DescriptionPdf: '',
      Description: '',
      PassengerOptions1: [
        {
          text: '1 Erwachsener',
          value: 1
        },
        {
          text: '2 Erwachsene',
          value: 2
        },
        {
          text: '3 Erwachsene',
          value: 3
        },
        {
          text: '4 Erwachsene',
          value: 4
        },
        {
          text: '5 Erwachsene',
          value: 5
        },
        {
          text: '6 Erwachsene',
          value: 6
        },
        {
          text: '7 Erwachsene',
          value: 7
        },
      ],
      PassengerOptions2: [
        {
          text: 'Keine Kinder',
          value: 0
        },
        {
          text: '+1 Kind',
          value: 1
        },
        {
          text: '+2 Kinder',
          value: 2
        },
        {
          text: '+3 Kinder',
          value: 3
        },
        {
          text: '+4 Kinder',
          value: 4
        },
        {
          text: '+5 Kinder',
          value: 5
        },
        {
          text: '+6 Kinder',
          value: 6
        },
        {
          text: '+7 Kinder',
          value: 7
        },
      ],
      Equipment: {
        value: {
          IdentId: 0,
          Price: 0,
          Name: '',
        },
        text: '',
      },
      DescriptionType: 0,
      EquipmentPrice: 0,
      EquipmentList: [],
      Passenger: {
        ageOfTheChild: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
        },

        Count: 0,
        Count2: 0,
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Flughafenservice Rech - Buchung'
    })

    console.log(this.$store.state.user)
    this.LoadEquipmentList()
  },
  methods: {
    async GetPrice() {
      await this.CalculatePrice()
    },
    async CalculatePrice() {
      const date = this.vData.Trip.TravelDay.split('.')
      let tDate = new Date(date[2] + '-' + date[1] + '-' + date[0])

      await this.$http.post('/voucher/calculatePrice', JSON.stringify({
        'fromId': 0,
        'toId': 0,
        'from': {
          'street': this.vData.Origin.Address.Street,
          'zipCode': this.vData.Origin.Address.ZipCode,
          'location': this.vData.Origin.Address.Location,
          'district': this.vData.Origin.Address.District
        },
        'to': {
          'street': this.vData.Destination.Address.Street,
          'zipCode': this.vData.Destination.Address.ZipCode,
          'location': this.vData.Destination.Address.Location,
          'district': this.vData.Destination.Address.District
        },
        'travelDay': tDate

      }))
          .then(resp => {
            if (resp.data.success) {
              if ((parseInt(this.vData.Passenger) + parseInt(this.vData.PassengersChildren)) > 3) {
                this.vData.Trip.Price = (parseFloat(resp.data.route.Price) + parseFloat(resp.data.route.Enter2) + parseFloat(this.vData.Equipment.Price))
                this.vData.ReturnTrip.Price = (parseFloat(resp.data.route.Price) + parseFloat(resp.data.route.Enter2) + parseFloat(this.vData.Equipment.Price))
              } else {
                this.vData.Trip.Price = (parseFloat(resp.data.route.Price) + parseFloat(resp.data.route.Enter1) + parseFloat(this.vData.Equipment.Price))
                this.vData.ReturnTrip.Price = (parseFloat(resp.data.route.Price) + parseFloat(resp.data.route.Enter1) + parseFloat(this.vData.Equipment.Price))
              }

              if (this.SelectedType == 2) {
                this.vData.Price = this.$options.filters.currency(this.vData.Trip.Price + this.vData.ReturnTrip.Price)
                this.vData.Trip.Price = this.$options.filters.currency(this.vData.Trip.Price)
                this.vData.ReturnTrip.Price = this.$options.filters.currency(this.vData.ReturnTrip.Price)
              } else {
                this.vData.Price = this.$options.filters.currency(this.vData.Trip.Price)
                this.vData.Trip.Price = this.$options.filters.currency(this.vData.Trip.Price)
              }
              this.Loading.Price = false
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    CalculateVat() {

      this.vData.Price = this.$refs.EuroFieldPrice.fieldData
      this.vData.PriceExtra = this.$refs.EuroFieldExtraPrice.fieldData
      const price = parseFloat(this.$refs.EuroFieldPrice.fieldData.toString()
          .replace(',', '.')) + parseFloat(this.$refs.EuroFieldExtraPrice.fieldData.toString()
          .replace(',', '.'))

      const identId = this.vData.Customer
      this.$http.post('/voucher/calculateVat', JSON.stringify({
        Price: price,
        CustomerIdentId: identId,
      }))
          .then(resp => {
            if (resp.data.Price > price) {
              this.VatRateLabel = `zzgl. (${resp.data.VarRate}%, ${this.$options.filters.currency(resp.data.VatPrice)})`
              this.EndSum = this.$options.filters.currency((resp.data.VatPrice + price))
            } else {

              this.VatRateLabel = `inkl. (${resp.data.VarRate}%, ${this.$options.filters.currency(resp.data.VatPrice)}`
              this.EndSum = this.$options.filters.currency((price))
            }
          })
          .catch(err => {
            console.error(err)
          })

      this.$refs.EuroFieldPrice.Blur()
      this.$refs.EuroFieldMedicalPrice.Blur()
      this.$refs.EuroFieldExtraPrice.Blur()

    },
    onTripDatePickerContext(ctx) {
      // The date formatted in the locale, or the `label-no - date - selected` string
      this.DatePicker.Trip.formatted = ctx.selectedFormatted
      // The following will be an empty string until a valid date is entered
      this.DatePicker.Trip.selected = ctx.selectedYMD
      this.vData.Trip.TravelDay = new Date(ctx.selectedYMD).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )
    },
    onReturnTripDatePickerContext(ctx) {
      // The date formatted in the locale, or the `label-no - date - selected` string
      this.DatePicker.ReturnTrip.formatted = ctx.selectedFormatted
      // The following will be an empty string until a valid date is entered
      this.DatePicker.ReturnTrip.selected = ctx.selectedYMD
      console.log(ctx.selectedYMD)
      this.vData.ReturnTrip.TravelDay = new Date(ctx.selectedYMD).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )
    },
    isValidDate: function (d) {
      const date = d.split('.')
      if (date.length != 3) {
        return false
      }
      const day = parseInt(date[0])
      if (day < 0 || day > 31) {
        return false
      }
      const month = parseInt(date[1])
      if (month < 0 || month > 12) {
        return false
      }
      const year = parseInt(date[2])
      const currentYear = new Date().getFullYear()
      if (year < (currentYear) || year > (currentYear + 4)) {
        return false
      }

      let TravelDay = new Date(date[2] + '-' + date[1] + '-' + date[0])
      if (TravelDay < new Date()) {
        return false
      }

      return true
    },
    AddStopover() {
      let stop = this.StopoverTemplate;

      this.vData.Stopovers.push(stop);
    },
    SetStep(id) {
      this.Step = id
      if (this.Step > 0) {
        if (this.SelectedType == 0) {
          this.Step = 0
          this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'ThumbsDownIcon',
                  text: 'Sie müssen einen Fahrttyp wählen.',
                  variant: 'warning',
                },
              },
              {
                timeout: 7000,
              })
        }
        if (this.Step == 2) {
          if (!this.isValidDate(this.vData.Trip.TravelDay)) {
            this.SetStep(1)
            this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'ThumbsDownIcon',
                    text: 'Reisetag ist enthält eine ungültige Eingabe oder ist außerhalb des buchbaren bereiches.',
                    variant: 'warning',
                  },
                },
                {
                  timeout: 7000,
                  position: 'bottom-center',
                  pauseOnHover: true,
                })
          } else if (this.SelectedType == 2) {
            if (!this.isValidDate(this.vData.ReturnTrip.TravelDay)) {
              this.SetStep(1)
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'ThumbsDownIcon',
                      text: 'Reisetag der Rückfahrt enthält eine ungültige Eingabe oder ist außerhalb des buchbaren bereiches.',
                      variant: 'warning',
                    },
                  },
                  {
                    timeout: 7000,
                    position: 'bottom-center',
                    pauseOnHover: true,
                  })
            } else {

            }
          }

        }
        if (this.Step == 3) {
          this.$refs.simpleRules.validate()
              .then(success => {
                if (!success) {
                  this.Step = 2
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Fehler',
                          icon: 'ThumbsDownIcon',
                          text: 'Fehlerhafte Eingabe. Bitte Rote Markierungen beachten.',
                          variant: 'danger',
                        },
                      },
                      {
                        timeout: 7000,
                      })
                }
              })
        }
        if (this.Step == 4) {
          if (this.vData.PassengersChildren > 0) {

            this.vData.Description1 = 'Kinder ('
            for (const [key, value] of Object.entries(this.Passenger.ageOfTheChild)) {
              if (parseInt(key) + 1 <= this.vData.PassengersChildren) {

                if (key > 0) {
                  this.vData.Description1 += ','
                }

                this.vData.Description1 += value
              }
            }
            this.vData.Description1 += ')'
          }
        }
        if (this.Step > 4 && this.DescriptionType == 0) {
          this.Step = 4
          this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'ThumbsDownIcon',
                  text: 'Sie müssen einen Zieloption wählen.',
                  variant: 'warning',
                },
              },
              {
                timeout: 7000,
              })
        }
        if (this.Step == 5) {
          this.GetPrice()
        }
      }
    },
    Finish() {

    },
    SelectDestinationType(type) {
      this.DescriptionType = type
      if (type == 1) {
        this.vData.Destination.Address.Street = 'Terminalring 11'
        this.vData.Destination.Address.ZipCode = '04435'
        this.vData.Destination.Address.Location = 'Schkeuditz'
        this.vData.Destination.Address.District = ''
      }
      if (type == 2) {
        this.vData.Destination.Address.Street = ''
        this.vData.Destination.Address.ZipCode = ''
        this.vData.Destination.Address.Location = ''
        this.vData.Destination.Address.District = ''
      }

    },
    GetIata(type) {
      if (type == 1) {
        let splitR = this.vData.Trip.TravelDay.split('.')
        this.$http.get(`flightPlan/iata/${this.vData.Origin.Flight.Iata}/${splitR[2]}-${splitR[1]}-${splitR[0]}`)
            .then(resp => {
              console.log(resp)
              if (resp.data.success) {
                this.vData.Origin.Flight.Arrivals = resp.data.flight.Arrivals
                this.vData.Origin.Flight.Departure = resp.data.flight.Departure
              }

            })
            .catch(err => {
              console.error(err)
            })
      }
    },
    LoadEquipmentList() {
      this.Equipment = 0
      this.EquipmentList = []
      this.EquipmentList.push({
        value: 0,
        text: 'Keine zusätzlichen Optionen',
      })

      this.$http.get('equipment/list')
          .then(resp => {
            resp.data.forEach(i => {
              console.log(i)
              let formatterPrice = new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR'
              })

              this.EquipmentList.push({
                value: i.Value,
                text: i.Value.Name + ' (+' + formatterPrice.format(i.Value.Price) + ')',
              })
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    SelectTravelType(type) {
      this.Step = 1
      this.SelectedType = type
      if (type == 1) {
        this.TravelData1.DayFieldName = 'Datum'
        this.TravelData2.DayFieldHidden = true
      } else {
        this.TravelData1.DayFieldName = 'Datum Hinfahrt'
        this.TravelData2.DayFieldHidden = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/tour.scss';
</style>
